/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Checkbox, Form, Input, Spin, Tooltip, BackTop } from 'antd';
import {
    ExclamationCircleOutlined,
    PlusCircleOutlined,
} from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBlocker } from '../../../util/usePrompt';
import { useNavigate, useParams } from 'react-router-dom';
import useNotify from '../../../context/Notification/useNotify';
import ModalDiscardChanges from '../../../components/Shared/modal/discardChanges';
import ModalConfirm from '../../../components/Shared/modal/confirm';
import RiskAssessmentService from '../../../services/RiskAssessment.service';
import { ROUTER } from '../../../constants/router';
import ModalDelete from '../../../components/Shared/modal/delete';

export default function Tab1({ detail, mode, getRiskAssessment, lastUpdate }) {
    const { t, i18n } = useTranslation();
    const [form] = Form.useForm();
    const { riskId } = useParams();
    const lang = i18n.language;
    const { TextArea } = Input;
    const [fields, setFields] = useState([]);
    const [statusForm, setStatusForm] = useState(true);
    const [checkExData, setCheckExData] = useState([]);
    const [riskFactorMaster, setRiskFactorMaster] = useState([]);
    const [nameDelete, setNameDelete] = useState('');
    const [loadingForm, setLoadingForm] = useState(false);

    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);
    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);
    const Navigate = useNavigate();
    const notify = useNotify();

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };
    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };
    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);
        await form.resetFields();
        await Navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
        await getRiskFactorMasterEx();
        await getRiskAssessment();
    };
    const changePage = () => {
        Navigate(`${ROUTER.RISK_MANAGEMENT.RA}/${riskId}/view?tab=1`);
    };
    // ConfirmDelete
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);

    // Confirm
    const [openConfirm, setOpenConfirm] = useState(false);
    const [valueSave, setValueSave] = useState();
    const [loading, setLoading] = useState(false);

    const onSubmit = async () => {
        if (mode === 'create') {
            // create
            const riskFactor = [];
            for (const item in riskFactorMaster) {
                if (valueSave[riskFactorMaster[item].riskId]) {
                    // console.log(valueSave[riskFactorMaster[item].riskId])
                    let subRiskFactor = [];
                    let subRiskAddon = [];
                    if (riskFactorMaster[item].subRisk) {
                        for (const i in riskFactorMaster[item].subRisk) {
                            if (
                                valueSave[
                                    riskFactorMaster[item].riskId
                                ].includes(
                                    riskFactorMaster[item].subRisk[i].subRiskId
                                )
                            ) {
                                let subRiskItem = [];
                                let riskItemAddOn = [];
                                // Add Sub RiskId
                                if (
                                    riskFactorMaster[item].subRisk[i].riskItem
                                ) {
                                    for (const e in riskFactorMaster[item]
                                        .subRisk[i].riskItem) {
                                        // Add RiskItem
                                        if (
                                            valueSave[
                                                riskFactorMaster[item].subRisk[
                                                    i
                                                ].subRiskId
                                            ]?.includes(
                                                riskFactorMaster[item]?.subRisk[
                                                    i
                                                ].riskItem[e].id
                                            )
                                        ) {
                                            subRiskItem.push({
                                                id: riskFactorMaster[item]
                                                    .subRisk[i].riskItem[e].id,
                                            });
                                        }
                                    }
                                    // RiskItem AddOn
                                    let ri = String(
                                        `riskItemAddOn${riskFactorMaster[item].subRisk[i].subRiskId}`
                                    );
                                    if (valueSave[ri]) {
                                        for (const el of valueSave[ri]) {
                                            // console.log(`${valueSave[ri].indexOf(el)} > `,el)
                                            riskItemAddOn.push({
                                                name: el.riskItemAddOnNameSubRisk,
                                                seq:
                                                    Number(
                                                        valueSave[ri].indexOf(
                                                            el
                                                        )
                                                    ) + 1,
                                            });
                                        }
                                    }
                                }
                                subRiskFactor.push({
                                    subRiskId:
                                        riskFactorMaster[item].subRisk[i]
                                            .subRiskId,
                                    riskItem: subRiskItem,
                                    riskItemAddOn: riskItemAddOn,
                                });
                            }
                        }
                    }

                    // SubRisk AddOn
                    let sr = String(
                        `subRiskAddOn${riskFactorMaster[item].riskId}`
                    );
                    if (valueSave[sr]) {
                        for (const el in valueSave[sr]) {
                            // console.log('valueSave[sr][el] ', valueSave[sr][el])
                            let riskItem = [];
                            let riskItemAddOn = [];
                            if (valueSave[sr][el].subRiskAddOnSubName) {
                                // AddOn SubRisk
                                riskItemAddOn.push({
                                    name: valueSave[sr][el].subRiskAddOnSubName,
                                    seq: '',
                                });
                                if (valueSave[sr][el].riskItemSubAddOn) {
                                    //  console.log('valueSave[sr][el].riskItemSubAddOn ', valueSave[sr][el].riskItemSubAddOn)
                                    for (const ee in valueSave[sr][el]
                                        .riskItemSubAddOn) {
                                        // AddOn SubRiskItem
                                        riskItemAddOn.push({
                                            name: valueSave[sr][el]
                                                .riskItemSubAddOn[ee]
                                                .riskItemSubAddOnName,
                                            seq: '',
                                        });
                                    }
                                }
                            }
                            const newRiskItemAddOn = riskItemAddOn.map((obj) =>
                                obj
                                    ? {
                                          ...obj,
                                          seq:
                                              Number(
                                                  riskItemAddOn.indexOf(obj)
                                              ) + 1,
                                      }
                                    : obj
                            );
                            subRiskAddon.push({
                                name: valueSave[sr][el].subRiskAddOnName,
                                seq: '',
                                riskItem: riskItem,
                                riskItemAddOn: newRiskItemAddOn,
                            });
                        }
                    }
                    const newsubRiskAddon = subRiskAddon.map((obj) =>
                        obj
                            ? {
                                  ...obj,
                                  seq: Number(subRiskAddon.indexOf(obj)) + 1,
                              }
                            : obj
                    );
                    // Add RiskId
                    riskFactor.push({
                        riskId: riskFactorMaster[item].riskId,
                        subRisk: subRiskFactor,
                        subRiskAddOn: newsubRiskAddon,
                    });
                    // console.log('valueSave ',item, valueSave[riskFactorMaster[item].riskId])
                }
            }
            // console.log('riskFactor ', riskFactor)

            const itemAddOn = [];
            if (valueSave.itemAddOn) {
                for (const item in valueSave.itemAddOn) {
                    //    console.log(valueSave.itemAddOn[item])
                    let subRiskAddOn = [];
                    // MainItem AddOn
                    if (valueSave.itemAddOn[item].riskMainAddOnName) {
                        let riskItemAddOn = [];
                        if (valueSave.itemAddOn[item].riskMainSubItem) {
                            for (const i in valueSave.itemAddOn[item]
                                .riskMainSubItem) {
                                //    console.log(valueSave.itemAddOn[item].riskMainSubItem[i])
                                riskItemAddOn.push({
                                    name: valueSave.itemAddOn[item]
                                        .riskMainSubItem[i].riskMainSubItemName,
                                    seq: Number(i) + 1,
                                });
                            }
                        }
                        subRiskAddOn.push({
                            name: valueSave.itemAddOn[item].riskMainAddOnName,
                            seq: Number(item) + 1,
                            riskItemAddOn: riskItemAddOn,
                        });
                    }
                    //Item AddOn
                    if (valueSave.itemAddOn[item].riskMainItemAddOn) {
                        for (const e in valueSave.itemAddOn[item]
                            .riskMainItemAddOn) {
                            // console.log(valueSave.itemAddOn[item].riskMainItemAddOn[e].riskMainItemName)
                            let riskItemAddOn2 = [];
                            if (
                                valueSave.itemAddOn[item].riskMainItemAddOn[e]
                                    .riskSubMainSubItem
                            ) {
                                for (const i in valueSave.itemAddOn[item]
                                    .riskMainItemAddOn[e].riskSubMainSubItem) {
                                    // console.log(valueSave.itemAddOn[item].riskMainItemAddOn[e].riskSubMainSubItem[i])
                                    riskItemAddOn2.push({
                                        name: valueSave.itemAddOn[item]
                                            .riskMainItemAddOn[e]
                                            .riskSubMainSubItem[i]
                                            .riskSubMainSubItemName,
                                        seq: Number(i) + 1,
                                    });
                                }
                            }
                            subRiskAddOn.push({
                                name: valueSave.itemAddOn[item]
                                    .riskMainItemAddOn[e].riskMainItemName,
                                seq: '',
                                riskItemAddOn: riskItemAddOn2,
                            });
                        }
                    }
                    const newSubRiskAddOn = subRiskAddOn.map((obj) =>
                        obj
                            ? {
                                  ...obj,
                                  seq: Number(subRiskAddOn.indexOf(obj)) + 1,
                              }
                            : obj
                    );
                    itemAddOn.push({
                        riskName: valueSave.itemAddOn[item].riskName,
                        riskDetail: valueSave.itemAddOn[item].riskDetail,
                        seq: Number(item) + 1,
                        subRiskAddOn: newSubRiskAddOn,
                    });
                }
            }
            // console.log('itemAddOn ', itemAddOn)
            // console.log(valueSave)
            // console.log({
            //     item: riskFactor ? riskFactor : [],
            //     itemAddOn: itemAddOn ? itemAddOn : [],
            // })
            try {
                const { data } = await RiskAssessmentService.createRiskFactor({
                    item: riskFactor ? riskFactor : [],
                    itemAddOn: itemAddOn ? itemAddOn : [],
                });
                if (data?.resultCode === 1) {
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully save data'),
                    });
                    setOpenChange(false);
                    setChange(false);
                    setLoading(false);
                    setOpenConfirm(false);
                    Navigate(
                        `${ROUTER.RISK_MANAGEMENT.RA}/${riskId}/view?tab=1`
                    );
                } else {
                    setOpenConfirm(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to save data'),
                    });
                }
            } catch (error) {
                console.log(error);
                setOpenConfirm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to save data'),
                });
            }
        } else {
            // edit
            // console.log('edit')
            // console.log('riskFactorMaster ', riskFactorMaster)
            // console.log('valueSave ', valueSave)
            // console.log('detail ', detail)

            const riskFactor = [];
            for (const item in riskFactorMaster) {
                if (valueSave[riskFactorMaster[item].riskId]) {
                    let subRiskFactor = [];
                    let subRiskAddon = [];
                    if (riskFactorMaster[item].subRisk) {
                        for (const i in riskFactorMaster[item].subRisk) {
                            if (
                                valueSave[
                                    riskFactorMaster[item].riskId
                                ].includes(
                                    riskFactorMaster[item].subRisk[i].subRiskId
                                )
                            ) {
                                let subRiskItem = [];
                                let riskItemAddOn = [];
                                // Add Sub RiskId
                                if (
                                    riskFactorMaster[item].subRisk[i].riskItem
                                ) {
                                    for (const e in riskFactorMaster[item]
                                        .subRisk[i].riskItem) {
                                        // Add RiskItem
                                        if (
                                            valueSave[
                                                riskFactorMaster[item].subRisk[
                                                    i
                                                ].subRiskId
                                            ].includes(
                                                riskFactorMaster[item].subRisk[
                                                    i
                                                ].riskItem[e].id
                                            )
                                        ) {
                                            subRiskItem.push({
                                                id: riskFactorMaster[item]
                                                    .subRisk[i].riskItem[e].id,
                                            });
                                        }
                                    }
                                    // RiskItem AddOn
                                    let ri = String(
                                        `riskItemAddOn${riskFactorMaster[item].subRisk[i].subRiskId}`
                                    );
                                    if (valueSave[ri]) {
                                        for (const el of valueSave[ri]) {
                                            // console.log(`${valueSave[ri].indexOf(el)} > `,el)
                                            riskItemAddOn.push({
                                                id: el.id || null, //get id
                                                name: el.riskItemAddOnNameSubRisk,
                                                seq:
                                                    Number(
                                                        valueSave[ri].indexOf(
                                                            el
                                                        )
                                                    ) + 1,
                                            });
                                        }
                                    }
                                }
                                subRiskFactor.push({
                                    id:
                                        findSubRiskId(
                                            detail.item,
                                            riskFactorMaster[item].subRisk[i]
                                                .subRiskId
                                        )?.subRisk[i]?.id || null,
                                    subRiskId:
                                        riskFactorMaster[item].subRisk[i]
                                            .subRiskId,
                                    riskItem: subRiskItem,
                                    riskItemAddOn: riskItemAddOn,
                                });
                            }
                        }
                    }

                    // SubRisk AddOn
                    let sr = String(
                        `subRiskAddOn${riskFactorMaster[item].riskId}`
                    );
                    if (valueSave[sr]) {
                        for (const el in valueSave[sr]) {
                            //  console.log('valueSave[sr][el] ', valueSave[sr][el])
                            let riskItem = [];
                            let riskItemAddOn = [];
                            if (valueSave[sr][el].subRiskAddOnSubName) {
                                // AddOn SubRisk
                                riskItemAddOn.push({
                                    id: valueSave[sr][el].id
                                        ? valueSave[sr][el].id
                                        : null,
                                    name: valueSave[sr][el].subRiskAddOnSubName,
                                    seq: '',
                                });
                                if (valueSave[sr][el].riskItemSubAddOn) {
                                    //  console.log('valueSave[sr][el].riskItemSubAddOn ', valueSave[sr][el].riskItemSubAddOn)
                                    for (const ee in valueSave[sr][el]
                                        .riskItemSubAddOn) {
                                        // AddOn SubRiskItem
                                        riskItemAddOn.push({
                                            id: valueSave[sr][el]
                                                .riskItemSubAddOn[ee].id
                                                ? valueSave[sr][el]
                                                      .riskItemSubAddOn[ee].id
                                                : null,
                                            name: valueSave[sr][el]
                                                .riskItemSubAddOn[ee]
                                                .riskItemSubAddOnName,
                                            seq: '',
                                        });
                                    }
                                }
                            }
                            const newRiskItemAddOn = riskItemAddOn.map((obj) =>
                                obj
                                    ? {
                                          ...obj,
                                          seq:
                                              Number(
                                                  riskItemAddOn.indexOf(obj)
                                              ) + 1,
                                      }
                                    : obj
                            );
                            subRiskAddon.push({
                                id: valueSave[sr][el].id
                                    ? valueSave[sr][el].id
                                    : null,
                                name: valueSave[sr][el].subRiskAddOnName,
                                seq: '',
                                riskItem: riskItem,
                                riskItemAddOn: newRiskItemAddOn,
                            });
                        }
                    }
                    const newsubRiskAddon = subRiskAddon.map((obj) =>
                        obj
                            ? {
                                  ...obj,
                                  seq: Number(subRiskAddon.indexOf(obj)) + 1,
                              }
                            : obj
                    );
                    // Add RiskId
                    riskFactor.push({
                        id:
                            findRiskId(
                                detail.item,
                                riskFactorMaster[item].riskId
                            )?.id || null,
                        riskId: riskFactorMaster[item].riskId,
                        subRisk: subRiskFactor,
                        subRiskAddOn: newsubRiskAddon,
                    });
                    // console.log('valueSave ',item, valueSave[riskFactorMaster[item].riskId])
                }
            }
            // console.log('riskFactor ', riskFactor)

            const itemAddOn = [];
            if (valueSave.itemAddOn) {
                for (const item in valueSave.itemAddOn) {
                    //    console.log(valueSave.itemAddOn[item])
                    let subRiskAddOn = [];
                    // MainItem AddOn
                    if (valueSave.itemAddOn[item].riskMainAddOnName) {
                        let riskItemAddOn = [];
                        if (valueSave.itemAddOn[item].riskMainSubItem) {
                            for (const i in valueSave.itemAddOn[item]
                                .riskMainSubItem) {
                                //    console.log(valueSave.itemAddOn[item].riskMainSubItem[i])
                                riskItemAddOn.push({
                                    id: valueSave.itemAddOn[item]
                                        .riskMainSubItem[i].id
                                        ? valueSave.itemAddOn[item]
                                              .riskMainSubItem[i].id
                                        : null,
                                    name: valueSave.itemAddOn[item]
                                        .riskMainSubItem[i].riskMainSubItemName,
                                    seq: Number(i) + 1,
                                });
                            }
                        }
                        subRiskAddOn.push({
                            id: valueSave.itemAddOn[item].id
                                ? valueSave.itemAddOn[item].id
                                : null,
                            name: valueSave.itemAddOn[item].riskMainAddOnName,
                            seq: Number(item) + 1,
                            riskItemAddOn: riskItemAddOn,
                        });
                    }
                    //Item AddOn
                    if (valueSave.itemAddOn[item].riskMainItemAddOn) {
                        for (const e in valueSave.itemAddOn[item]
                            .riskMainItemAddOn) {
                            // console.log(valueSave.itemAddOn[item].riskMainItemAddOn[e].riskMainItemName)
                            let riskItemAddOn2 = [];
                            if (
                                valueSave.itemAddOn[item].riskMainItemAddOn[e]
                                    .riskSubMainSubItem
                            ) {
                                for (const i in valueSave.itemAddOn[item]
                                    .riskMainItemAddOn[e].riskSubMainSubItem) {
                                    // console.log(valueSave.itemAddOn[item].riskMainItemAddOn[e].riskSubMainSubItem[i])
                                    riskItemAddOn2.push({
                                        id: valueSave.itemAddOn[item]
                                            .riskMainItemAddOn[e]
                                            .riskSubMainSubItem[i].id
                                            ? valueSave.itemAddOn[item]
                                                  .riskMainItemAddOn[e]
                                                  .riskSubMainSubItem[i].id
                                            : null,
                                        name: valueSave.itemAddOn[item]
                                            .riskMainItemAddOn[e]
                                            .riskSubMainSubItem[i]
                                            .riskSubMainSubItemName,
                                        seq: Number(i) + 1,
                                    });
                                }
                            }
                            subRiskAddOn.push({
                                id: valueSave.itemAddOn[item].riskMainItemAddOn[
                                    e
                                ].id
                                    ? valueSave.itemAddOn[item]
                                          .riskMainItemAddOn[e].id
                                    : null,
                                name: valueSave.itemAddOn[item]
                                    .riskMainItemAddOn[e].riskMainItemName,
                                seq: '',
                                riskItemAddOn: riskItemAddOn2,
                            });
                        }
                    }
                    const newSubRiskAddOn = subRiskAddOn.map((obj) =>
                        obj
                            ? {
                                  ...obj,
                                  seq: Number(subRiskAddOn.indexOf(obj)) + 1,
                              }
                            : obj
                    );
                    itemAddOn.push({
                        id: valueSave.itemAddOn[item].id
                            ? valueSave.itemAddOn[item].id
                            : null,
                        riskName: valueSave.itemAddOn[item].riskName,
                        riskDetail: valueSave.itemAddOn[item].riskDetail,
                        seq: Number(item) + 1,
                        subRiskAddOn: newSubRiskAddOn,
                    });
                }
            }
            // console.log('itemAddOn ', itemAddOn)

            try {
                const { data } = await RiskAssessmentService.updateRiskFactor({
                    item: riskFactor ? riskFactor : [],
                    itemAddOn: itemAddOn ? itemAddOn : [],
                });
                if (data?.resultCode === 1) {
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully save data'),
                    });
                    setOpenChange(false);
                    setChange(false);
                    setLoading(false);
                    setOpenConfirm(false);
                    Navigate(
                        `${ROUTER.RISK_MANAGEMENT.RA}/${riskId}/view?tab=1`
                    );
                } else {
                    setOpenConfirm(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to save data'),
                    });
                }
            } catch (error) {
                console.log(error);
                setOpenConfirm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to save data'),
                });
            }
        }
    };

    const findRiskId = (array, riskId) => {
        return array.find((element) => {
            return element.riskId === riskId;
        });
    };

    const findSubRiskId = (array, subRiskId) => {
        return array.find((element) => {
            return element.subRisk?.find((item) => {
                return item.subRiskId === subRiskId;
            });
        });
    };
    const getRiskFactorMasterEx = async () => {
        setLoadingForm(true);
        const { data } = await RiskAssessmentService.getRiskFactorMaster();
        if (data.resultData) {
            const items = data.resultData.item;
            items?.forEach((element) => {
                element.subRisk?.forEach((item) => {
                    if (item.riskItem?.length) {
                        setCheckExData((prevState) => {
                            const newState = prevState.map((obj) => {
                                if (obj.nameValue === item.subRiskId) {
                                    return { ...obj, checked: false };
                                }
                                return obj;
                            });
                            return newState;
                        });
                    }
                });
            });
            await setRiskFactorMaster(data.resultData.item);
            await setFieldsDetail();
        }
    };
    useEffect(() => {
        setLoadingForm(true);
        const getRiskFactorMaster = async () => {
            const { data } = await RiskAssessmentService.getRiskFactorMaster();
            if (data.resultData) {
                const items = data.resultData.item;
                items?.forEach((element) => {
                    element.subRisk?.forEach((item) => {
                        if (item.riskItem?.length) {
                            setCheckExData((checkExData) => [
                                ...checkExData,
                                {
                                    nameValue: item.subRiskId,
                                    checked: false,
                                },
                            ]);
                        }
                    });
                });
                await setRiskFactorMaster(data.resultData.item);
                await setFieldsDetail();
            }
        };
        getRiskFactorMaster();
    }, [detail]);

    const setFieldsDetail = async () => {
        if (detail) {
            detail.item?.forEach((element) => {
                let subRisk = [];
                element.subRisk?.forEach((item) => {
                    subRisk.push(item.subRiskId);
                    setCheckExData((prevState) => {
                        const newState = prevState.map((obj) => {
                            if (obj.nameValue === `${item.subRiskId}`) {
                                return { ...obj, checked: true };
                            }
                            return obj;
                        });
                        return newState;
                    });
                    let riskItem = [];
                    if (item.riskItem.length) {
                        item.riskItem?.forEach((i) => {
                            riskItem.push(i.mRiskFactorSubOptionId);
                        });
                        // Set RiskItem
                        setFields([
                            {
                                // id: item.id,
                                name: `${item.subRiskId}`,
                                value: riskItem,
                            },
                        ]);
                    }
                    if (item.riskItemAddOn.length) {
                        let riskItemAddOn = [];
                        item.riskItemAddOn?.forEach((i) => {
                            riskItemAddOn.push({
                                id: i.id,
                                riskItemAddOnNameSubRisk: i.name,
                            });
                        });
                        // Set RiskItemAddOn
                        setFields([
                            {
                                // id:item.id,
                                name: `riskItemAddOn${item.subRiskId}`,
                                value: riskItemAddOn,
                            },
                        ]);
                    }
                });
                //sub risk add on
                let subRiskAddOn = [];
                element.subRiskAddOn?.forEach((item) => {
                    if (item.riskItemAddOn.length) {
                        let riskItemAddOn = [];
                        item.riskItemAddOn?.forEach((i, index) => {
                            if (index > 0) {
                                riskItemAddOn.push({
                                    id: i.id,
                                    riskItemSubAddOnName: i.name,
                                });
                            }
                        });
                        // subRiskAddOn ปัจจัยหลัก+ปัจจัยย่อย
                        subRiskAddOn.push({
                            id: item.id,
                            subRiskAddOnName: item.name,
                            subRiskAddOnSubName: item.riskItemAddOn[0].name,
                            riskItemSubAddOn: riskItemAddOn,
                        });
                    } else {
                        // subRiskAddOn ปัจจัยหลัก
                        subRiskAddOn.push({
                            id: item.id,
                            subRiskAddOnName: item.name,
                        });
                    }
                });
                // Set SubRiskAddOn
                setFields([
                    {
                        name: `subRiskAddOn${element.riskId}`,
                        value: subRiskAddOn,
                    },
                ]);
                // Set SubRiskId
                setFields([
                    {
                        name: `${element.riskId}`,
                        value: subRisk,
                    },
                ]);
            });
            // ItemAddOn //
            let ItemAddOn = [];
            detail.itemAddOn?.forEach((element) => {
                // console.log(element)
                let riskMainSubItem = [];
                let riskMainItemAddOn = [];
                if (element.subRiskAddOn.length) {
                    //subRiskAddOn
                    let riskSubMainSubItem = [];
                    element.subRiskAddOn?.forEach((item, index) => {
                        if (index > 0) {
                            // console.log(item)
                            if (item.riskItemAddOn.length) {
                                item.riskItemAddOn?.forEach((i) => {
                                    riskSubMainSubItem.push({
                                        id: i.id,
                                        riskSubMainSubItemName: i.name,
                                    });
                                });
                            }
                            riskMainItemAddOn.push({
                                id: item.id,
                                riskMainItemName: item.name,
                                riskSubMainSubItem: riskSubMainSubItem,
                            });
                        } else {
                            if (item.riskItemAddOn.length) {
                                item.riskItemAddOn?.forEach((i) => {
                                    riskMainSubItem.push({
                                        id: i.id,
                                        riskMainSubItemName: i.name,
                                    });
                                });
                            }
                        }
                    });
                    ItemAddOn.push({
                        id: element.id,
                        riskName: element.riskName,
                        riskDetail: element.riskDetail,
                        riskMainAddOnName: element.subRiskAddOn[0].name,
                        riskMainSubItem: riskMainSubItem,
                        riskMainItemAddOn: riskMainItemAddOn,
                    });
                }
            });
            setFields([
                {
                    name: 'itemAddOn',
                    value: ItemAddOn,
                },
            ]);
            setStatusForm(false);
            setLoadingForm(false);
        }
    };

    const checkFieldsAddon = (_, value) => {
        const fieldName = _.field;
        if (
            form.getFieldValue(`${fieldName}`)?.length > 0 ||
            (form.getFieldValue(`riskItemAddOn${fieldName}`) &&
                form.getFieldValue(`riskItemAddOn${fieldName}`)?.length > 0)
        ) {
            return Promise.resolve();
        }
        return Promise.reject(new Error(t('errorText.requiredField')));
    };

    return (
        <>
            <Spin spinning={loadingForm}>
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    layout="vertical"
                    form={form}
                    fields={fields}
                    onFinish={(value) => {
                        setOpenConfirm(true);
                        setValueSave(value);
                        const newItem = value;
                        for (let key in newItem) {
                            if (
                                newItem.hasOwnProperty(key) &&
                                newItem[key] === undefined
                            ) {
                                newItem[key] = [];
                            }
                        }
                        setValueSave(newItem);
                        // console.log(newItem)
                        // console.log(value)
                    }}
                    onFinishFailed={(value) => {
                        console.log('value failed ', value);
                    }}
                    onFieldsChange={(_, allFields) => {
                        if (allFields.length > 0) {
                            setChange(true);
                        }
                    }}
                    onValuesChange={(_, allValues) => {
                        const keyValue = Object.values(allValues);
                        let iHave = 0;
                        let iNo = 0;
                        keyValue?.forEach((i) => {
                            if (i) {
                                iHave = iHave + 1;
                                if (allValues.itemAddOn.length) {
                                    const keyItemAddOn = Object.values(
                                        allValues.itemAddOn
                                    );
                                    if (!keyItemAddOn[0]) {
                                        iHave = iHave - 1;
                                    } else {
                                        if (
                                            !keyItemAddOn[0]
                                                .riskMainItemAddOn &&
                                            !keyItemAddOn[0].riskMainSubItem
                                        ) {
                                            iHave = iHave - 1;
                                        }
                                    }
                                }
                                if (i?.length <= 0) {
                                    iNo = iNo + 1;
                                }
                            }
                        });
                        if (iHave - iNo > 0) {
                            // console.log('have data')
                            setStatusForm(false);
                            form.setFields([
                                {
                                    name: 'allData',
                                    errors: [''],
                                },
                            ]);
                        }
                    }}
                >
                    <div className="p-4">
                        <div
                            className="mb-4"
                            style={{ borderBottom: '3px solid #F4F6FC' }}
                        >
                            <div className="flex justify-between">
                                <div className="flex space-x-2 items-center pb-2">
                                    <div className="text-2xl font-bold pb-1">
                                        {t('RA.RiskFactor')}
                                    </div>
                                    <Tooltip
                                        overlayStyle={{
                                            minWidth: '18%',
                                        }}
                                        placement="rightTop"
                                        title={t('Tooltip.RiskFactor')}
                                    >
                                        <a className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm">
                                            <ExclamationCircleOutlined />
                                        </a>
                                    </Tooltip>
                                </div>
                                <div className="flex space-x-4 items-center">
                                    <Button
                                        size="large"
                                        type="default"
                                        className="text-purple-PHX border-purple-PHX w-32"
                                        onClick={changePage}
                                    >
                                        {t('common.Cancel')}
                                    </Button>
                                    <Button
                                        size="large"
                                        type="primary"
                                        className="w-32"
                                        htmlType="submit"
                                    >
                                        {t('common.Save')}
                                    </Button>
                                </div>
                            </div>

                            <div className="pb-6 flex items-center">
                                <div className="font-bold">
                                    {t('Last Update')} :{' '}
                                </div>
                                <div className="ml-1">
                                    {lastUpdate?.riskFactorUpdateDate || '-'}
                                </div>
                            </div>
                        </div>

                        {riskFactorMaster?.map((item) => (
                            <div className="grid grid-cols-3" key={item.riskId}>
                                <div className="col-span-2 p-4 mb-4 box-content">
                                    <div className="text-base font-semibold mb-1">
                                        {lang === 'en'
                                            ? item.riskNameEn
                                            : item.riskNameTh}
                                    </div>
                                    <div className="text-sm mb-1">
                                        {lang === 'en'
                                            ? item.riskDetailEn
                                            : item.riskDetailTh}
                                    </div>
                                    <Form.Item
                                        className="mt-4"
                                        name={`${item.riskId}`}
                                        label={
                                            <span className="text-base font-semibold">
                                                {t('RA.MainRiskFactors')}
                                            </span>
                                        }
                                    >
                                        <Checkbox.Group className="w-full mb-1">
                                            {item.subRisk.map((is) => {
                                                return (
                                                    <div key={is.subRiskId}>
                                                        {is.riskItem.length >
                                                        0 ? (
                                                            <>
                                                                {/* <<<<< checkbox ปัจจัยความเสี่ยงหลัก แบบมีปัจจัยความเสี่ยงย่อย >>>>> */}
                                                                <Checkbox
                                                                    key={
                                                                        is.subRiskId
                                                                    }
                                                                    value={
                                                                        is.subRiskId
                                                                    }
                                                                    style={{
                                                                        lineHeight:
                                                                            '32px',
                                                                    }}
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        setCheckExData(
                                                                            (
                                                                                prevState
                                                                            ) => {
                                                                                const newState =
                                                                                    prevState.map(
                                                                                        (
                                                                                            obj
                                                                                        ) => {
                                                                                            if (
                                                                                                obj.nameValue ===
                                                                                                e
                                                                                                    .target
                                                                                                    .value
                                                                                            ) {
                                                                                                return {
                                                                                                    ...obj,
                                                                                                    checked:
                                                                                                        e
                                                                                                            .target
                                                                                                            .checked,
                                                                                                };
                                                                                            }
                                                                                            return obj;
                                                                                        }
                                                                                    );
                                                                                return newState;
                                                                            }
                                                                        );
                                                                    }}
                                                                >
                                                                    {lang ===
                                                                    'en'
                                                                        ? is.subRiskNameEn
                                                                        : is.subRiskNameTh}
                                                                    <span
                                                                        className="px-2"
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                        }}
                                                                    >
                                                                        {is.subRiskDetailEn ? (
                                                                            <Tooltip
                                                                                overlayStyle={{
                                                                                    minWidth:
                                                                                        '18%',
                                                                                }}
                                                                                placement="rightTop"
                                                                                title={
                                                                                    lang ===
                                                                                    'en'
                                                                                        ? is.subRiskDetailEn
                                                                                        : is.subRiskDetailTh
                                                                                }
                                                                            >
                                                                                <span className="text-purple">
                                                                                    <ExclamationCircleOutlined />
                                                                                </span>
                                                                            </Tooltip>
                                                                        ) : (
                                                                            <>

                                                                            </>
                                                                        )}

                                                                        {is
                                                                            .riskItem
                                                                            .length >
                                                                        0 ? (
                                                                            <>
                                                                                {checkExData?.find(
                                                                                    (
                                                                                        f
                                                                                    ) =>
                                                                                        f.nameValue ===
                                                                                            is.subRiskId &&
                                                                                        f.checked ===
                                                                                            true
                                                                                )
                                                                                    ? upIcon
                                                                                    : downIcon}
                                                                            </>
                                                                        ) : (
                                                                            <>

                                                                            </>
                                                                        )}
                                                                    </span>
                                                                </Checkbox>
                                                                {checkExData?.find(
                                                                    (f) =>
                                                                        f.nameValue ===
                                                                            is.subRiskId &&
                                                                        f.checked ===
                                                                            true
                                                                ) && (
                                                                    <div
                                                                        style={{
                                                                            background:
                                                                                '#EEE5FF',
                                                                        }}
                                                                        className="p-4 rounded-md ml-5 mt-4 box-content"
                                                                    >
                                                                        {/* <<<<< ปัจจัยความเสี่ยงย่อย >>>>> */}
                                                                        <Form.Item
                                                                            className="mt-4"
                                                                            name={[
                                                                                `${is.subRiskId}`,
                                                                            ]}
                                                                            label={
                                                                                <span className="text-base font-semibold">
                                                                                    {t(
                                                                                        'RA.MinorRiskFactors'
                                                                                    )}
                                                                                </span>
                                                                            }
                                                                            rules={[
                                                                                {
                                                                                    validator:
                                                                                        checkFieldsAddon,
                                                                                    // message:t('errorText.requiredField'),
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Checkbox.Group className="w-full mb-1">
                                                                                {is.riskItem.map(
                                                                                    (
                                                                                        i
                                                                                    ) => {
                                                                                        return (
                                                                                            <div
                                                                                                key={
                                                                                                    i.id
                                                                                                }
                                                                                            >
                                                                                                <Checkbox
                                                                                                    key={
                                                                                                        i.id
                                                                                                    }
                                                                                                    value={
                                                                                                        i.id
                                                                                                    }
                                                                                                    style={{
                                                                                                        lineHeight:
                                                                                                            '32px',
                                                                                                    }}
                                                                                                >
                                                                                                    {lang ===
                                                                                                    'en'
                                                                                                        ? i.nameEn
                                                                                                        : i.nameTh}{' '}
                                                                                                    {i.descriptionEn ? (
                                                                                                        <Tooltip
                                                                                                            overlayStyle={{
                                                                                                                minWidth:
                                                                                                                    '18%',
                                                                                                            }}
                                                                                                            placement="rightTop"
                                                                                                            title={
                                                                                                                lang ===
                                                                                                                'en'
                                                                                                                    ? i.descriptionEn
                                                                                                                    : i.descriptionTh
                                                                                                            }
                                                                                                        >
                                                                                                            <span className="text-purple">
                                                                                                                <ExclamationCircleOutlined />
                                                                                                            </span>
                                                                                                        </Tooltip>
                                                                                                    ) : (
                                                                                                        <>

                                                                                                        </>
                                                                                                    )}
                                                                                                </Checkbox>
                                                                                                <br />
                                                                                            </div>
                                                                                        );
                                                                                    }
                                                                                )}
                                                                                {/* เพิ่มปัจจัยความเสี่ยงย่อย มี 1แบบ */}
                                                                                <Form.List
                                                                                    name={`riskItemAddOn${is.subRiskId}`}
                                                                                >
                                                                                    {(
                                                                                        fields,
                                                                                        {
                                                                                            add,
                                                                                            remove,
                                                                                        }
                                                                                    ) => (
                                                                                        <>
                                                                                            {fields.map(
                                                                                                (
                                                                                                    {
                                                                                                        key,
                                                                                                        name,
                                                                                                        ...restField
                                                                                                    },
                                                                                                    i
                                                                                                ) => (
                                                                                                    <div
                                                                                                        key={
                                                                                                            key
                                                                                                        }
                                                                                                        className="flex mt-1"
                                                                                                    >
                                                                                                        <Form.Item
                                                                                                            className="mb-2 w-full"
                                                                                                            {...restField}
                                                                                                            name={[
                                                                                                                name,
                                                                                                                `riskItemAddOnNameSubRisk`,
                                                                                                            ]}
                                                                                                            rules={[
                                                                                                                {
                                                                                                                    required: true,
                                                                                                                    message:
                                                                                                                        t(
                                                                                                                            'errorText.requiredField'
                                                                                                                        ),
                                                                                                                },
                                                                                                            ]}
                                                                                                        >
                                                                                                            <Input
                                                                                                                placeholder={t(
                                                                                                                    'dataFlow.inputpl'
                                                                                                                )}
                                                                                                                size="large"
                                                                                                                className="pr-12 bg-white"
                                                                                                            />
                                                                                                        </Form.Item>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="cursor-pointer hover:opacity-80 absolute right-0 p-1"
                                                                                                            onClick={() => {
                                                                                                                remove(
                                                                                                                    name
                                                                                                                );
                                                                                                                form.validateFields();
                                                                                                            }}
                                                                                                        >
                                                                                                            {
                                                                                                                DeleteIcon
                                                                                                            }
                                                                                                        </button>
                                                                                                    </div>
                                                                                                )
                                                                                            )}
                                                                                            <Form.Item className="mb-0">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="text-blue-400 hover:opacity-80 cursor-pointer font-semibold"
                                                                                                    onClick={() => {
                                                                                                        add();
                                                                                                        form.setFields(
                                                                                                            [
                                                                                                                {
                                                                                                                    name: `${is.subRiskId}`,
                                                                                                                    errors: [],
                                                                                                                },
                                                                                                            ]
                                                                                                        );
                                                                                                    }}
                                                                                                >
                                                                                                    <PlusCircleOutlined />{' '}
                                                                                                    {t(
                                                                                                        'RA.AddMinorRiskFactors'
                                                                                                    )}
                                                                                                </button>
                                                                                            </Form.Item>
                                                                                        </>
                                                                                    )}
                                                                                </Form.List>
                                                                            </Checkbox.Group>
                                                                        </Form.Item>
                                                                    </div>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <>
                                                                {/* <<<<< checkbox ปัจจัยความเสี่ยงหลัก แบบปกติ >>>>> */}
                                                                <Checkbox
                                                                    key={
                                                                        is.subRiskId
                                                                    }
                                                                    value={
                                                                        is.subRiskId
                                                                    }
                                                                    style={{
                                                                        lineHeight:
                                                                            '32px',
                                                                    }}
                                                                >
                                                                    {lang ===
                                                                    'en'
                                                                        ? is.subRiskNameEn
                                                                        : is.subRiskNameTh}
                                                                    <span
                                                                        className="px-2"
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                        }}
                                                                    >
                                                                        {is.subRiskDetailEn ? (
                                                                            <Tooltip
                                                                                overlayStyle={{
                                                                                    minWidth:
                                                                                        '18%',
                                                                                }}
                                                                                placement="rightTop"
                                                                                title={
                                                                                    lang ===
                                                                                    'en'
                                                                                        ? is.subRiskDetailEn
                                                                                        : is.subRiskDetailTh
                                                                                }
                                                                            >
                                                                                <span className="text-purple">
                                                                                    <ExclamationCircleOutlined />
                                                                                </span>
                                                                            </Tooltip>
                                                                        ) : (
                                                                            <>

                                                                            </>
                                                                        )}
                                                                    </span>
                                                                </Checkbox>
                                                            </>
                                                        )}
                                                        <br />
                                                    </div>
                                                );
                                            })}
                                            {/* เพิ่มปัจจัยความเสี่ยงหลัก มี 2 แบบ */}
                                            {item.subRisk.find(
                                                (el) => el.riskItem.length > 0
                                            ) ? (
                                                <Form.List
                                                    name={`subRiskAddOn${item.riskId}`}
                                                >
                                                    {(
                                                        fields,
                                                        { add, remove }
                                                    ) => (
                                                        <>
                                                            {fields.map(
                                                                (
                                                                    {
                                                                        key1,
                                                                        name,
                                                                        ...restField
                                                                    },
                                                                    i
                                                                ) => (
                                                                    <div
                                                                        key={
                                                                            key1
                                                                        }
                                                                        className="relative mt-4"
                                                                    >
                                                                        <Form.Item
                                                                            className="mb-2 w-full"
                                                                            {...restField}
                                                                            // name={[name,`subRiskAddOnName${item.seq}`]}
                                                                            name={[
                                                                                name,
                                                                                `subRiskAddOnName`,
                                                                            ]}
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                    message:
                                                                                        t(
                                                                                            'errorText.requiredField'
                                                                                        ),
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Input
                                                                                placeholder={t(
                                                                                    'dataFlow.inputpl'
                                                                                )}
                                                                                size="large"
                                                                                className="pr-12 bg-white"
                                                                            />
                                                                        </Form.Item>
                                                                        <div
                                                                            className="p-4 rounded-md ml-5 mt-4 box-content"
                                                                            style={{
                                                                                background:
                                                                                    '#EEE5FF',
                                                                            }}
                                                                        >
                                                                            <Form.Item
                                                                                className="mb-2 w-full"
                                                                                {...restField}
                                                                                // name={[name,`subRiskItemAddOnName2_${item.seq}`]}
                                                                                name={[
                                                                                    name,
                                                                                    `subRiskAddOnSubName`,
                                                                                ]}
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message:
                                                                                            t(
                                                                                                'errorText.requiredField'
                                                                                            ),
                                                                                    },
                                                                                ]}
                                                                            >
                                                                                <Input
                                                                                    placeholder={t(
                                                                                        'dataFlow.inputpl'
                                                                                    )}
                                                                                    size="large"
                                                                                    className="pr-12 bg-white mb-2"
                                                                                />
                                                                            </Form.Item>
                                                                            {/* AddOnRiskItem เพิ่มปัจจัยความเสี่ยงย่อย*/}
                                                                            <Form.List
                                                                                name={[
                                                                                    name,
                                                                                    `riskItemSubAddOn`,
                                                                                ]}
                                                                            >
                                                                                {(
                                                                                    fields,
                                                                                    {
                                                                                        add,
                                                                                        remove,
                                                                                    }
                                                                                ) => (
                                                                                    <>
                                                                                        {fields.map(
                                                                                            (
                                                                                                {
                                                                                                    key,
                                                                                                    name,
                                                                                                    ...restField
                                                                                                },
                                                                                                i
                                                                                            ) => (
                                                                                                <div
                                                                                                    key={
                                                                                                        key
                                                                                                    }
                                                                                                    className="flex mt-1"
                                                                                                >
                                                                                                    <Form.Item
                                                                                                        className="mb-2 w-full"
                                                                                                        {...restField}
                                                                                                        name={[
                                                                                                            name,
                                                                                                            `riskItemSubAddOnName`,
                                                                                                        ]}
                                                                                                        rules={[
                                                                                                            {
                                                                                                                required: true,
                                                                                                                message:
                                                                                                                    t(
                                                                                                                        'errorText.requiredField'
                                                                                                                    ),
                                                                                                            },
                                                                                                        ]}
                                                                                                    >
                                                                                                        <Input
                                                                                                            placeholder={t(
                                                                                                                'dataFlow.inputpl'
                                                                                                            )}
                                                                                                            size="large"
                                                                                                            className="pr-12 bg-white"
                                                                                                        />
                                                                                                    </Form.Item>
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="cursor-pointer hover:opacity-80 absolute right-4 p-1"
                                                                                                        onClick={() =>
                                                                                                            remove(
                                                                                                                name
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        {
                                                                                                            DeleteIcon
                                                                                                        }
                                                                                                    </button>
                                                                                                </div>
                                                                                            )
                                                                                        )}
                                                                                        <Form.Item className="mb-0">
                                                                                            <button
                                                                                                type="button"
                                                                                                className="text-blue-400 hover:opacity-80 cursor-pointer font-semibold"
                                                                                                onClick={() => {
                                                                                                    add();
                                                                                                }}
                                                                                            >
                                                                                                <PlusCircleOutlined />{' '}
                                                                                                {t(
                                                                                                    'RA.AddMinorRiskFactors'
                                                                                                )}
                                                                                            </button>
                                                                                        </Form.Item>
                                                                                    </>
                                                                                )}
                                                                            </Form.List>
                                                                        </div>
                                                                        <button
                                                                            type="button"
                                                                            className="cursor-pointer hover:opacity-80 absolute top-0 right-0 p-1"
                                                                            onClick={() =>
                                                                                remove(
                                                                                    name
                                                                                )
                                                                            }
                                                                        >
                                                                            {
                                                                                DeleteIcon
                                                                            }
                                                                        </button>
                                                                    </div>
                                                                )
                                                            )}
                                                            <Form.Item className="mb-0">
                                                                <button
                                                                    type="button"
                                                                    className="text-blue-400 hover:opacity-80 cursor-pointer font-semibold"
                                                                    onClick={() => {
                                                                        add();
                                                                    }}
                                                                >
                                                                    <PlusCircleOutlined />{' '}
                                                                    {t(
                                                                        'RA.AddMainRiskFactors'
                                                                    )}
                                                                </button>
                                                            </Form.Item>
                                                        </>
                                                    )}
                                                </Form.List>
                                            ) : (
                                                <Form.List
                                                    name={`subRiskAddOn${item.riskId}`}
                                                >
                                                    {(
                                                        fields,
                                                        { add, remove }
                                                    ) => (
                                                        <>
                                                            {fields.map(
                                                                (
                                                                    {
                                                                        key,
                                                                        name,
                                                                        ...restField
                                                                    },
                                                                    i
                                                                ) => (
                                                                    <div
                                                                        key={
                                                                            key
                                                                        }
                                                                        className="flex mt-1"
                                                                    >
                                                                        <Form.Item
                                                                            className="mb-2 w-full"
                                                                            {...restField}
                                                                            name={[
                                                                                name,
                                                                                `subRiskAddOnName`,
                                                                            ]}
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                    message:
                                                                                        t(
                                                                                            'errorText.requiredField'
                                                                                        ),
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Input
                                                                                placeholder={t(
                                                                                    'dataFlow.inputpl'
                                                                                )}
                                                                                size="large"
                                                                                className="pr-12 bg-white"
                                                                            />
                                                                        </Form.Item>
                                                                        <button
                                                                            type="button"
                                                                            className="cursor-pointer hover:opacity-80 absolute right-0 p-1"
                                                                            onClick={() =>
                                                                                remove(
                                                                                    name
                                                                                )
                                                                            }
                                                                        >
                                                                            {
                                                                                DeleteIcon
                                                                            }
                                                                        </button>
                                                                    </div>
                                                                )
                                                            )}
                                                            <Form.Item className="mb-0">
                                                                <button
                                                                    type="button"
                                                                    className="text-blue-400 hover:opacity-80 cursor-pointer font-semibold"
                                                                    onClick={() => {
                                                                        add();
                                                                    }}
                                                                >
                                                                    <PlusCircleOutlined />{' '}
                                                                    {t(
                                                                        'RA.AddMainRiskFactors'
                                                                    )}
                                                                </button>
                                                            </Form.Item>
                                                        </>
                                                    )}
                                                </Form.List>
                                            )}
                                        </Checkbox.Group>
                                    </Form.Item>
                                </div>
                            </div>
                        ))}

                        {/* เพิ่มประเภทความเสี่ยง */}

                        <Form.List name="itemAddOn">
                            {(fields, { add, remove }) => (
                                <>
                                    {fields.map(
                                        ({ key, name, ...restField }, i) => (
                                            <div
                                                className="grid grid-cols-3 "
                                                key={key}
                                            >
                                                <div className="col-span-2 p-4 mb-4 box-content mt-1 relative">
                                                    <div className="text-base mb-1">
                                                        {/* ชื่อหัวข้อประเภทความเสี่ยง */}
                                                        <Form.Item
                                                            className="mb-2 w-full"
                                                            {...restField}
                                                            label={
                                                                <span className="text-base font-semibold">
                                                                    {t(
                                                                        'RA.TopicRiskFactorsType'
                                                                    )}
                                                                </span>
                                                            }
                                                            name={[
                                                                name,
                                                                `riskName`,
                                                            ]}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: t(
                                                                        'errorText.requiredField'
                                                                    ),
                                                                },
                                                            ]}
                                                        >
                                                            <Input
                                                                placeholder={t(
                                                                    'RA.TopicInputpl'
                                                                )}
                                                                size="large"
                                                                className="pr-12 bg-white"
                                                            />
                                                        </Form.Item>

                                                        <div className="text-sm mb-1">
                                                            {/* รายละเอียด detail */}
                                                            <Form.Item
                                                                {...restField}
                                                                name={[
                                                                    name,
                                                                    `riskDetail`,
                                                                ]}
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message:
                                                                            t(
                                                                                'errorText.requiredField'
                                                                            ),
                                                                    },
                                                                ]}
                                                            >
                                                                <TextArea
                                                                    size="large"
                                                                    className="bg-white"
                                                                    rows={4}
                                                                    placeholder={t(
                                                                        'RA.DetailInputpl'
                                                                    )}
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                        <div className="text-sm">
                                                            {/* ปัจจัยความเสี่ยงหลัก */}
                                                            <Form.Item
                                                                className="mb-2 w-full"
                                                                {...restField}
                                                                label={
                                                                    <span className="text-base font-semibold">
                                                                        {t(
                                                                            'RA.MainRiskFactors'
                                                                        )}
                                                                    </span>
                                                                }
                                                                name={[
                                                                    name,
                                                                    `riskMainAddOnName`,
                                                                ]}
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message:
                                                                            t(
                                                                                'errorText.requiredField'
                                                                            ),
                                                                    },
                                                                ]}
                                                            >
                                                                <Input
                                                                    placeholder={t(
                                                                        'dataFlow.inputpl'
                                                                    )}
                                                                    size="large"
                                                                    className="pr-12 bg-white"
                                                                />
                                                            </Form.Item>
                                                            {/* เพิ่มปัจจัยความเสี่ยงย่อย */}
                                                            <Form.List
                                                                name={[
                                                                    name,
                                                                    `riskMainSubItem`,
                                                                ]}
                                                            >
                                                                {(
                                                                    fields,
                                                                    {
                                                                        add,
                                                                        remove,
                                                                    }
                                                                ) => (
                                                                    <div
                                                                        className="p-4 rounded-md ml-5 mt-4 box-content"
                                                                        style={{
                                                                            background:
                                                                                '#EEE5FF',
                                                                        }}
                                                                    >
                                                                        {fields.map(
                                                                            (
                                                                                {
                                                                                    key,
                                                                                    name,
                                                                                    ...restField
                                                                                },
                                                                                i
                                                                            ) => (
                                                                                <div
                                                                                    key={
                                                                                        key
                                                                                    }
                                                                                    className="flex mt-1"
                                                                                >
                                                                                    <Form.Item
                                                                                        className="mb-2 w-full"
                                                                                        {...restField}
                                                                                        name={[
                                                                                            name,
                                                                                            `riskMainSubItemName`,
                                                                                        ]}
                                                                                        rules={[
                                                                                            {
                                                                                                required: true,
                                                                                                message:
                                                                                                    t(
                                                                                                        'errorText.requiredField'
                                                                                                    ),
                                                                                            },
                                                                                        ]}
                                                                                    >
                                                                                        <Input
                                                                                            placeholder={t(
                                                                                                'dataFlow.inputpl'
                                                                                            )}
                                                                                            size="large"
                                                                                            className="pr-12 bg-white"
                                                                                        />
                                                                                    </Form.Item>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="cursor-pointer hover:opacity-80 absolute right-8 p-1"
                                                                                        onClick={() =>
                                                                                            remove(
                                                                                                name
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        {
                                                                                            DeleteIcon
                                                                                        }
                                                                                    </button>
                                                                                </div>
                                                                            )
                                                                        )}
                                                                        <Form.Item className="mb-0">
                                                                            <button
                                                                                type="button"
                                                                                className="text-blue-400 hover:opacity-80 cursor-pointer font-semibold"
                                                                                onClick={() =>
                                                                                    add()
                                                                                }
                                                                            >
                                                                                <PlusCircleOutlined />{' '}
                                                                                {t(
                                                                                    'RA.AddMinorRiskFactors'
                                                                                )}
                                                                            </button>
                                                                        </Form.Item>
                                                                    </div>
                                                                )}
                                                            </Form.List>

                                                            {/* เพิ่มปัจจัยความเสี่ยงหลัก + ปัจจัยความเสี่ยงย่อย */}
                                                            <Form.List
                                                                name={[
                                                                    name,
                                                                    `riskMainItemAddOn`,
                                                                ]}
                                                            >
                                                                {(
                                                                    fields,
                                                                    {
                                                                        add,
                                                                        remove,
                                                                    }
                                                                ) => (
                                                                    <>
                                                                        {fields.map(
                                                                            (
                                                                                {
                                                                                    key,
                                                                                    name,
                                                                                    ...restField
                                                                                },
                                                                                i
                                                                            ) => (
                                                                                <div
                                                                                    key={
                                                                                        key
                                                                                    }
                                                                                    className="relative mt-4"
                                                                                >
                                                                                    <Form.Item
                                                                                        className="mb-2 w-full"
                                                                                        {...restField}
                                                                                        name={[
                                                                                            name,
                                                                                            `riskMainItemName`,
                                                                                        ]}
                                                                                        rules={[
                                                                                            {
                                                                                                required: true,
                                                                                                message:
                                                                                                    t(
                                                                                                        'errorText.requiredField'
                                                                                                    ),
                                                                                            },
                                                                                        ]}
                                                                                    >
                                                                                        <Input
                                                                                            placeholder={t(
                                                                                                'dataFlow.inputpl'
                                                                                            )}
                                                                                            size="large"
                                                                                            className="pr-12 bg-white"
                                                                                        />
                                                                                    </Form.Item>
                                                                                    <Form.List
                                                                                        name={[
                                                                                            name,
                                                                                            `riskSubMainSubItem`,
                                                                                        ]}
                                                                                    >
                                                                                        {(
                                                                                            fields,
                                                                                            {
                                                                                                add,
                                                                                                remove,
                                                                                            }
                                                                                        ) => (
                                                                                            <div
                                                                                                style={{
                                                                                                    background:
                                                                                                        '#EEE5FF',
                                                                                                }}
                                                                                                className="p-4 rounded-md ml-5 mt-4 box-content"
                                                                                            >
                                                                                                {fields.map(
                                                                                                    (
                                                                                                        {
                                                                                                            key,
                                                                                                            name,
                                                                                                            ...restField
                                                                                                        },
                                                                                                        i
                                                                                                    ) => (
                                                                                                        <div
                                                                                                            key={
                                                                                                                key
                                                                                                            }
                                                                                                            className="relative mt-1"
                                                                                                        >
                                                                                                            <Form.Item
                                                                                                                className="mb-4 w-full"
                                                                                                                {...restField}
                                                                                                                name={[
                                                                                                                    name,
                                                                                                                    `riskSubMainSubItemName`,
                                                                                                                ]}
                                                                                                                rules={[
                                                                                                                    {
                                                                                                                        required: true,
                                                                                                                        message:
                                                                                                                            t(
                                                                                                                                'errorText.requiredField'
                                                                                                                            ),
                                                                                                                    },
                                                                                                                ]}
                                                                                                            >
                                                                                                                <Input
                                                                                                                    placeholder={t(
                                                                                                                        'dataFlow.inputpl'
                                                                                                                    )}
                                                                                                                    size="large"
                                                                                                                    className="pr-12 bg-white"
                                                                                                                />
                                                                                                            </Form.Item>
                                                                                                            <button
                                                                                                                type="button"
                                                                                                                className="cursor-pointer hover:opacity-80 absolute top-0 right-0 p-1"
                                                                                                                onClick={() =>
                                                                                                                    remove(
                                                                                                                        name
                                                                                                                    )
                                                                                                                }
                                                                                                            >
                                                                                                                {
                                                                                                                    DeleteIcon
                                                                                                                }
                                                                                                            </button>
                                                                                                        </div>
                                                                                                    )
                                                                                                )}
                                                                                                <Form.Item className="mb-0">
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="text-blue-400 hover:opacity-80 cursor-pointer font-semibold"
                                                                                                        onClick={() =>
                                                                                                            add()
                                                                                                        }
                                                                                                    >
                                                                                                        <PlusCircleOutlined />{' '}
                                                                                                        {t(
                                                                                                            'RA.AddMinorRiskFactors'
                                                                                                        )}
                                                                                                    </button>
                                                                                                </Form.Item>
                                                                                            </div>
                                                                                        )}
                                                                                    </Form.List>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="cursor-pointer hover:opacity-80 absolute top-0 right-0 p-1"
                                                                                        onClick={() =>
                                                                                            remove(
                                                                                                name
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        {
                                                                                            DeleteIcon
                                                                                        }
                                                                                    </button>
                                                                                </div>
                                                                            )
                                                                        )}
                                                                        <Form.Item className="mb-0">
                                                                            <button
                                                                                type="button"
                                                                                className="text-blue-400 hover:opacity-80 cursor-pointer font-semibold"
                                                                                onClick={() =>
                                                                                    add()
                                                                                }
                                                                            >
                                                                                <PlusCircleOutlined />{' '}
                                                                                {t(
                                                                                    'RA.AddMainRiskFactors'
                                                                                )}
                                                                            </button>
                                                                        </Form.Item>
                                                                    </>
                                                                )}
                                                            </Form.List>
                                                        </div>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="cursor-pointer hover:opacity-80 absolute top-0 right-0 p-3"
                                                        onClick={() => {
                                                            setOpenConfirmDelete(
                                                                true
                                                            );
                                                            setNameDelete(name);
                                                        }}
                                                    >
                                                        {DeleteIcon2}
                                                    </button>
                                                    <ModalDelete
                                                        title={t(
                                                            'common.ConfirmDelete'
                                                        )}
                                                        text={t(
                                                            'RA.modalDelete'
                                                        )}
                                                        open={openConfirmDelete}
                                                        handelOk={() => {
                                                            remove(nameDelete);
                                                            setOpenConfirmDelete(
                                                                false
                                                            );
                                                            setNameDelete('');
                                                            notify({
                                                                title: t(
                                                                    'common.Success'
                                                                ),
                                                                description:
                                                                    'Successfully to submitted.',
                                                            });
                                                        }}
                                                        handelClose={() =>
                                                            setOpenConfirmDelete(
                                                                false
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        )
                                    )}
                                    <Form.Item className="mb-0">
                                        <button
                                            type="button"
                                            className="text-blue-400 hover:opacity-80 cursor-pointer font-semibold"
                                            onClick={() => add()}
                                        >
                                            <PlusCircleOutlined />{' '}
                                            {t('RA.AddTopicRiskFactorsType')}
                                        </button>
                                    </Form.Item>
                                </>
                            )}
                        </Form.List>
                        <Form.Item
                            style={{ marginTop: '-0.65%' }}
                            name={'allData'}
                            rules={[
                                {
                                    required: statusForm,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        ></Form.Item>
                    </div>
                </Form>
            </Spin>
            <BackTop>
                <div style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <ModalConfirm
                loading={loading}
                text={t('Do you want to confirm')}
                open={openConfirm}
                handelOk={onSubmit}
                handelClose={() => setOpenConfirm(false)}
            />
        </>
    );
}
const DeleteIcon = (
    <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width={32} height={32} rx={6} fill="white" />
        <path
            d="M15.9998 9C16.5487 8.99992 17.0778 9.20504 17.4832 9.57509C17.8887 9.94513 18.1411 10.4534 18.191 11H21.5998C21.7518 11 21.8982 11.0578 22.0092 11.1616C22.1203 11.2654 22.1879 11.4074 22.1982 11.5591C22.2086 11.7108 22.161 11.8607 22.0651 11.9786C21.9691 12.0966 21.832 12.1737 21.6814 12.1944L21.5998 12.2H21.1334L20.1198 20.984C20.0747 21.3739 19.8878 21.7336 19.5947 21.9947C19.3016 22.2558 18.9227 22.4001 18.5302 22.4H13.4694C13.0769 22.4001 12.698 22.2558 12.4049 21.9947C12.1118 21.7336 11.9249 21.3739 11.8798 20.984L10.8654 12.2H10.3998C10.2548 12.2 10.1147 12.1475 10.0055 12.0522C9.89619 11.9569 9.82512 11.8252 9.8054 11.6816L9.7998 11.6C9.79981 11.455 9.85232 11.3149 9.94762 11.2057C10.0429 11.0964 10.1746 11.0253 10.3182 11.0056L10.3998 11H13.8086C13.8585 10.4534 14.1109 9.94513 14.5164 9.57509C14.9218 9.20504 15.4509 8.99992 15.9998 9ZM14.7998 14C14.6038 14 14.4398 14.124 14.4062 14.2872L14.3998 14.3504V19.2504L14.4062 19.3128C14.4398 19.476 14.6038 19.6 14.7998 19.6C14.9958 19.6 15.1598 19.476 15.1934 19.3128L15.1998 19.2496V14.3512L15.1934 14.2872C15.1598 14.1248 14.9958 14 14.7998 14ZM17.1998 14C17.0038 14 16.8398 14.124 16.8062 14.2872L16.7998 14.3504V19.2504L16.8062 19.3128C16.8398 19.476 17.0038 19.6 17.1998 19.6C17.3958 19.6 17.5598 19.476 17.5934 19.3128L17.5998 19.2496V14.3512L17.5934 14.2872C17.5598 14.1248 17.3958 14 17.1998 14ZM15.9998 10.2C15.5158 10.2 15.1118 10.544 15.0198 11H16.9798C16.887 10.544 16.4838 10.2 15.9998 10.2Z"
            fill="#7B67FB"
        />
    </svg>
);
const DeleteIcon2 = (
    <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="32" height="32" rx="6" fill="#EEE5FF" />
        <path
            d="M15.9998 9C16.5487 8.99992 17.0778 9.20504 17.4832 9.57509C17.8887 9.94513 18.1411 10.4534 18.191 11H21.5998C21.7518 11 21.8982 11.0578 22.0092 11.1616C22.1203 11.2654 22.1879 11.4074 22.1982 11.5591C22.2086 11.7108 22.161 11.8607 22.0651 11.9786C21.9691 12.0966 21.832 12.1737 21.6814 12.1944L21.5998 12.2H21.1334L20.1198 20.984C20.0747 21.3739 19.8878 21.7336 19.5947 21.9947C19.3016 22.2558 18.9227 22.4001 18.5302 22.4H13.4694C13.0769 22.4001 12.698 22.2558 12.4049 21.9947C12.1118 21.7336 11.9249 21.3739 11.8798 20.984L10.8654 12.2H10.3998C10.2548 12.2 10.1147 12.1475 10.0055 12.0522C9.89619 11.9569 9.82512 11.8252 9.8054 11.6816L9.7998 11.6C9.79981 11.455 9.85232 11.3149 9.94762 11.2057C10.0429 11.0964 10.1746 11.0253 10.3182 11.0056L10.3998 11H13.8086C13.8585 10.4534 14.1109 9.94513 14.5164 9.57509C14.9218 9.20504 15.4509 8.99992 15.9998 9ZM14.7998 14C14.6038 14 14.4398 14.124 14.4062 14.2872L14.3998 14.3504V19.2504L14.4062 19.3128C14.4398 19.476 14.6038 19.6 14.7998 19.6C14.9958 19.6 15.1598 19.476 15.1934 19.3128L15.1998 19.2496V14.3512L15.1934 14.2872C15.1598 14.1248 14.9958 14 14.7998 14ZM17.1998 14C17.0038 14 16.8398 14.124 16.8062 14.2872L16.7998 14.3504V19.2504L16.8062 19.3128C16.8398 19.476 17.0038 19.6 17.1998 19.6C17.3958 19.6 17.5598 19.476 17.5934 19.3128L17.5998 19.2496V14.3512L17.5934 14.2872C17.5598 14.1248 17.3958 14 17.1998 14ZM15.9998 10.2C15.5158 10.2 15.1118 10.544 15.0198 11H16.9798C16.887 10.544 16.4838 10.2 15.9998 10.2Z"
            fill="#7B67FB"
        />
    </svg>
);
const upIcon = (
    <svg
        width="10"
        height="11"
        viewBox="0 0 10 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.55996 2.70053C5.17087 2.43655 4.63699 2.47694 4.29222 2.82171L1.46379 5.65014C1.07327 6.04066 1.07327 6.67382 1.46379 7.06435C1.85432 7.45487 2.48748 7.45487 2.87801 7.06435L4.99933 4.94303L7.12068 7.06438C7.5112 7.4549 8.14437 7.4549 8.53489 7.06438C8.92542 6.67385 8.92542 6.04069 8.53489 5.65016L5.70647 2.82174C5.70158 2.81685 5.69665 2.81202 5.69169 2.80726C5.65018 2.7674 5.60609 2.73183 5.55996 2.70053Z"
            fill="#171717"
        />
    </svg>
);
const downIcon = (
    <svg
        width="10"
        height="11"
        viewBox="0 0 10 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.44004 8.29947C4.82913 8.56345 5.36301 8.52306 5.70778 8.17829L8.53621 5.34986C8.92673 4.95934 8.92673 4.32618 8.53621 3.93565C8.14568 3.54513 7.51252 3.54513 7.12199 3.93565L5.00067 6.05697L2.87932 3.93562C2.4888 3.5451 1.85563 3.5451 1.46511 3.93562C1.07458 4.32615 1.07458 4.95931 1.46511 5.34984L4.29353 8.17826C4.29842 8.18315 4.30335 8.18798 4.30831 8.19274C4.34982 8.2326 4.39391 8.26817 4.44004 8.29947Z"
            fill="#171717"
        />
    </svg>
);
const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
